import { useSiteSettings } from '../context/SiteSettingsContext';

export default function WhatsAppButton() {
    const { settings } = useSiteSettings();
    if (!settings.whatsapp) return null;

    return (
        <a
            href={`https://wa.me/${settings.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-float"
            aria-label="WhatsApp ile iletişime geçin"
        >
            <svg viewBox="0 0 32 32" width="28" height="28" fill="#fff">
                <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.9 15.9 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.316 22.612c-.396 1.116-1.95 2.042-3.21 2.312-.864.182-1.99.328-5.786-1.244-4.856-2.012-7.978-6.93-8.22-7.252-.232-.322-1.95-2.6-1.95-4.96s1.234-3.52 1.672-4.002c.438-.482.956-.604 1.274-.604.318 0 .636.004.914.016.294.014.688-.112 1.076.822.396.956 1.352 3.298 1.47 3.538.118.24.196.52.04.838-.158.322-.236.52-.47.8-.236.282-.496.63-.708.844-.236.24-.482.498-.206.976.274.478 1.222 2.016 2.624 3.266 1.804 1.606 3.324 2.104 3.796 2.34.47.236.748.198 1.024-.118.274-.318 1.19-1.388 1.508-1.866.316-.478.634-.396 1.072-.236.438.158 2.778 1.31 3.254 1.548.478.236.796.358.914.554.118.198.118 1.14-.278 2.256v-.028z"/>
            </svg>
        </a>
    );
}
